module.exports = __webpack_public_path__ + "static/media/chevolet.d8a04807.png";